import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { CalculoFichaFinanceiraDTO, FichaFinanceiraService } from '../../../../folha-pagamento/src/calculo/ficha-financeira.service';

@Injectable()
export class PortalFichaFinanceiraService extends FichaFinanceiraService {

  private readonly resourcePortal: string = '/api/portal-servidor/ficha-financeira';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getCalculoDetalhesPorProgFerias(id: number): Observable<CalculoFichaFinanceiraDTO> {
    return this.httpClient.get({
      resource: `${this.resourcePortal}/programacao-ferias/${id}/detalhes`
    });
  }

  public findQuantidadeByFuncionarioIdAndCompetenciaId(funcionarioId: number, competenciaId: number): Observable<number> {
    return this.httpClient.get({
      resource: `${this.resourcePortal}/quantidade/${funcionarioId}/${competenciaId}`
    });
  }
}
